/**
 * Enum trạng thái chứng từ
 * tvhien 24.10.2023
 */
export default {
  UnPosted: 0,
  Posted: 1,
};
